import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../../../../ui/label';
import Input from '../../../../ui/input';
import ButtonDropdownOption from '../../../../ui/button-dropdown-option';
import NatureOfBusiness from '../../modal/nature-of-business/nature-of-business-modal';
import ClientAffiliation from './client-affiliation';
import { setBasicInformation, setCompanyNumber, setOpenTypeOfOptions, } from '../../../../../features/gms-proposal-forms/basic-information/basic-information.slice';
import { setTypeModal, } from '../../../../../features/gms-state-and-modal/modal-slice';
import { ContactPersonIcon, MingcuteBuilding5Line, } from '../../../../../assets/icon/iconify';
import { customStyle, defaultStyle, } from '../../../../../constant/custom-style';
import { useMediaQuery } from '../../../../../hooks/common/use-media-query';
import { useIsCompleteProposalAs } from '../../../../../hooks/proposal/use-state-checker-proposal';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { companyId, contactNumberId, typeOfSuffix, } from '../../../../../constant/gms-constant';
import { formatTinNumber } from '../../../../../utils/tin-number-formater.utils';
import { useCreateProposalForm } from '../../../../../hooks/actions/use-create-proposal-form';
import { selectProposalCurrentGroupName } from '../../../../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';
import { useModalAccess } from '../../../../global/modal/use-modal-access';

export default function ClientInputBasicInfo() {

    const dispatch = useDispatch();
    const {
        basicInformation,
        groupName,
        noOfLives,
        companyMobileNo,
        companyTelephone,
        completeBusinessAddress,
        proposalAddress,
        email,
        addressDesignation,
        designation,
        contactPersonSalutation,
        contactPersonFirstName,
        contactPersonMiddleName,
        contactPersonLastName,
        contactNumber,
        contactTelephone,
        tinNumber,
        secNumber,

        natureOfBusinessItem,
        companyTypeNumber,
        companyContactNumber,
        contactPersonNumber,

        isOpenTypeOfOption: isOpenTypeId
    } = useProposalTypeData()
    const { 
        debouncedGroupName, 
        existingCompany, 
        isFetchingExistingCompany 
    } = useCreateProposalForm();
    const { 
        typeOfCompanyNumber, 
        isLoadingTypeOfCompanyNumber, 
        typeOfContactNumber, 
        isLoadingTypeOfContactNumber, 
    } = useQueries();
    const {
        isUpdateProposal,
        isShowIndustries
    } = useModalAccess()
    
    const isDesktop = useMediaQuery('(min-width: 1024px)');
    const iconSize: number = isDesktop ? 18 : 16;
    const isComplete = useIsCompleteProposalAs();

    const { tinNumberOption, secNumberOption, } = useMemo(() => {
        const tinNumber = typeOfCompanyNumber?.find((item) => item.id === companyId.tinNumber.id);
        const secNumber = typeOfCompanyNumber?.find((item) => item.id === companyId.secNumber.id);
        return {
            tinNumberOption: tinNumber ? { id: tinNumber.id, name: tinNumber.name, } : null,
            secNumberOption: secNumber ? { id: secNumber.id, name: secNumber.name, } : null,
        };
    }, [typeOfCompanyNumber]);

    const companyNumberOptions = useMemo(() => {
        return (
            typeOfCompanyNumber?.map((item) => ({
                id: item.id,
                name: item.name,
            })) || []
        );
    }, [typeOfCompanyNumber]);

    const companyNumberValue = useMemo(() => {
        return (
            companyNumberOptions.find(
                (opt) => opt.id === companyTypeNumber?.id
            ) || companyNumberOptions[1]
        );
    }, [companyNumberOptions, companyTypeNumber?.id]);

    useEffect(() => {
        if (!companyTypeNumber?.id && companyNumberOptions.length > 1) {
            dispatch(
                setCompanyNumber({
                    type: 'comNumber',
                    value: companyNumberOptions[1],
                })
            );
        }
    }, [ companyTypeNumber?.id, companyNumberOptions, dispatch, ]);

    const companyContactNumberOptions = useMemo(() => {
        return (
            typeOfContactNumber?.map((item) => ({
                id: item.id,
                name: item.name,
            })) || []
        );
    }, [typeOfContactNumber]);

    const companyCompanyNumberValue = useMemo(() => {
        return (
            companyContactNumberOptions.find(
                (opt) => opt.id === companyContactNumber?.id
            ) || null
        );
    }, [ companyContactNumberOptions, companyContactNumber, companyTelephone, companyMobileNo ]);
    
    useEffect(() => {
        if ( !companyContactNumber && companyContactNumberOptions.length > 1 ) {
            dispatch(
                setCompanyNumber({
                    type: 'comContactNumber',
                    value: companyContactNumberOptions[1],
                })
            );
        }
    }, [ companyContactNumber, companyContactNumberOptions, dispatch, companyTelephone, companyMobileNo ]);

    const companyContactPersonNumberValue = useMemo(() => {
        return (
            companyContactNumberOptions.find(
                (opt) => opt.id === contactPersonNumber?.id
            ) || null
        );
    }, [ companyContactNumberOptions, contactPersonNumber, ]);

    useEffect(() => {
        if ( !contactPersonNumber && companyContactNumberOptions.length > 1 ) {
            dispatch(
                setCompanyNumber({
                    type: 'contactPersonNumber',
                    value: companyContactNumberOptions[1],
                })
            );
        }
    }, [ contactPersonNumber, companyContactNumberOptions, dispatch, ]);

    const handleChange = ( e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> ) => {
        const { name, value } = e.target;
        // if (name === "contactNumber" || name === "companyMobileNo" || name === 'tinNumber' || name === 'secNumber' || name === 'companyTelephone' || name === 'contactTelephone') {
        if (name === "contactNumber" || name === "companyMobileNo" || name === 'secNumber' || name === 'companyTelephone' || name === 'contactTelephone') {
            dispatch(setBasicInformation({ field: name as keyof typeof basicInformation, value }));
        } else if (name === "tinNumber") {
            const digits = value.replace(/\D/g, '').slice(0, 14);
            dispatch(setBasicInformation({ field: name as keyof typeof basicInformation, value: Number(digits) }));
        } else if (name === "noOfLives") {
            const digitsOnly = value.toString().replace(/\D/g, "");
            dispatch(setBasicInformation({ field: name as keyof typeof basicInformation, value: Number(digitsOnly) }));
        } else {
            dispatch(setBasicInformation({ field: name as keyof typeof basicInformation, value }));
        }
    };

    const hasValueCompanyNumber =
        companyCompanyNumberValue?.id === contactNumberId.mobile.id
            ? companyMobileNo.trim() !== ''
            : companyTelephone.trim() !== '';

    const hasValueContactPersonNumber =
        companyContactPersonNumberValue?.id === contactNumberId.mobile.id
            ? contactNumber.trim() !== ''
            : contactTelephone.trim() !== '';

    const contactPersonSuffix = useMemo(() => {
        return (
            typeOfSuffix.find(
                (opt) =>
                    opt.name ===
                    contactPersonSalutation
            ) || typeOfSuffix[0]
        );
    }, [contactPersonSalutation]);

    const currentGroupName = groupName ?? "";
    const originalGroupName = useSelector(selectProposalCurrentGroupName) ?? "";
    const normalizeGroupName = (value: string) => value.trim().replace(/\s+/g, " ").toLowerCase();
    const isGroupNameChanged = normalizeGroupName(originalGroupName) !== normalizeGroupName(currentGroupName);
    const shouldValidateGroupName = 
        !!debouncedGroupName && (!isUpdateProposal || isGroupNameChanged);


    return (
        <div className="rounded border border-gray-200 bg-white p-3.5 md:p-4 lg:col-span-3">
            {/* ============================================================
                BASIC INFORMATION HEADER
            ============================================================ */}
            <div className="flex items-center space-x-2 mb-1">
                <div className="rounded bg-[#186db233] p-1">
                    <MingcuteBuilding5Line width={iconSize} height={iconSize} />
                </div>
                <Label
                    label='Basic Information'
                    fontWeight="font-semibold text-gray-800"
                    fontSize="text-xs"
                    requiredText=' *'
                    isRequired={true}
                />
            </div>

            <div className="space-y-2">
                {/* ========================================================
                    BASIC INFORMATION FIELDS
                ======================================================== */}
                <div className="grid grid-cols-1 gap-2 text-xs md:grid-cols-2 lg:grid-cols-4">
                    {/* SEC REGISTERED NAME */}
                    <div>
                        <Label
                            label="SEC Registered Name"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="groupName"
                            value={groupName}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${!groupName ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="ABC Corporation"
                            disabled={!isComplete}
                        />
                        {shouldValidateGroupName && (
                            <>
                                {isFetchingExistingCompany && (
                                    <span className="text-xs text-gray-500">
                                        Checking company name...
                                    </span>
                                )}

                                {!isFetchingExistingCompany &&
                                    existingCompany?.data.company_exists === true && (
                                        <span className="text-xs text-red-500">
                                            {/* Group name already exists. */}
                                            {existingCompany.message ?? 'Group name already exists.'}
                                        </span>
                                    )}

                                {!isFetchingExistingCompany &&
                                    existingCompany?.data.company_exists === false && (
                                        <span className="text-xs text-green-600">
                                            {existingCompany.message ?? 'Group name already exists.'}
                                            {/* Group name is available. */}
                                        </span>
                                    )}
                            </>
                        )}
                        {/* {!isUpdate && (
                            <>
                                {isFetchingExistingCompany && (
                                    <span className="text-xs text-gray-500">
                                        Checking company name...
                                    </span>
                                )}
                                {!isFetchingExistingCompany && existingCompany?.data.exists === true && (
                                    <span className="text-xs text-red-500">
                                        Group name already exists.
                                    </span>
                                )}
                                {!isFetchingExistingCompany && debouncedGroupName && existingCompany?.data.exists === false && (
                                    <span className="text-xs text-green-600">
                                        Group name is available.
                                    </span>
                                )}
                            </>
                        )} */}
                    </div>
                    {/* NATURE OF BUSINESS */}
                    <div>
                        <Label
                            label="Nature of Business"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="natureOfBusiness"
                            value={natureOfBusinessItem?.name ?? 'Select nature of business' }
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !natureOfBusinessItem?.name ? 'italic font-medium cursor-pointer' : `cursor-pointer ${customStyle}` }`}
                            onclick={() => dispatch(setTypeModal( 'showIndustries' ))}
                            required={true}
                            placeholder=""
                            disabled={!isComplete}
                        />
                    </div>

                    {/* NO. OF LIVES */}
                    <div>
                        <Label
                            label="No. of Lives"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="noOfLives"
                            value={noOfLives}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !noOfLives ? '' : customStyle }`}
                            onChange={handleChange}
                            required={true}
                            placeholder=""
                            disabled={!isComplete}
                        />
                    </div>

                    {/* COMPLETE BUSINESS ADDRESS */}
                    <div>
                        <Label
                            label="Complete Business Address"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="completeBusinessAddress"
                            value={completeBusinessAddress}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !completeBusinessAddress ? '' : customStyle }`}
                            onChange={handleChange}
                            required={true}
                            placeholder="1234 Mabini Street, Barangay San Isidro, Quezon City, Metro Manila, Philippines 1100"
                            disabled={!isComplete}
                        />
                    </div>

                    {/* PROPOSAL ADDRESSEE */}
                    <div>
                        <Label
                            label="Proposal Addressee"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="proposalAddress"
                            value={proposalAddress}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${!proposalAddress ? '' : customStyle}`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Juan Dela Cruz"
                            disabled={!isComplete}
                        />
                    </div>

                    {/* ADDRESSEE DESIGNATION */}
                    <div>
                        <Label
                            label="Addressee Designation"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="addressDesignation"
                            value={addressDesignation}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${!addressDesignation ? '' : customStyle }`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Branch Manager"
                            disabled={!isComplete}
                        />
                    </div>

                    {/* ====================================================
                        TIN NUMBER
                    ==================================================== */}
                    <div className="col-span-2 md:col-span-1">
                        <Label
                            label="TIN Number (optional)"
                            fontSize="text-xs mb-1"
                        />
                        <div className={`${tinNumber ? '' : '' } flex rounded border overflow-hidden focus-within:border-[#186cb2] border-gray-300`}>
                            <ButtonDropdownOption
                                isShowArrow={false}
                                isDisable={!isComplete}
                                width="w-auto"
                                padding="px-2 py-[6px] rounded-l rounded-r-none border-none"
                                options={[]}
                                isLoading={isLoadingTypeOfCompanyNumber}
                                value={tinNumberOption}
                                onChange={(option) => {
                                    dispatch(setCompanyNumber({ type: 'comNumber',value: option }));
                                    dispatch(setBasicInformation({ field: 'tinNumber',value: '' }));
                                }}
                                open={ isOpenTypeId === 'typeOfId' }
                                isNoBorder={true}
                                setOpen={() =>
                                    dispatch(setOpenTypeOfOptions(isOpenTypeId ==='typeOfId' ? null: 'typeOfId'))
                                }
                            />
                            <Input
                                type="text"
                                name={'tinNumber'}
                                value={formatTinNumber(tinNumber)}
                                isCustomStyle={true}
                                customCss={`rounded-tr rounded-br w-full text-xs px-2 py-1.5 outline-none ${!tinNumber ? '' : customStyle }`}
                                onChange={handleChange}
                                placeholder="000-000-000-00000"
                                required={true}
                                disabled={!isComplete}
                            />
                        </div>
                    </div>

                    {/* ====================================================
                        SEC NUMBER
                    ==================================================== */}
                    <div className="col-span-2 md:col-span-1">
                        <Label
                            label="SEC Number (optional)"
                            fontSize="text-xs mb-1"
                        />
                        <div className={`${secNumber ? '' : '' } flex rounded border overflow-hidden focus-within:border-[#186cb2] border-gray-300 `}>
                            <ButtonDropdownOption
                                isShowArrow={false}
                                isDisable={!isComplete}
                                width="w-auto"
                                padding="px-2 py-[6px] rounded-l rounded-r-none border-none"
                                options={[]}
                                isLoading={isLoadingTypeOfCompanyNumber}
                                value={secNumberOption}
                                onChange={(option) => {
                                    dispatch(setCompanyNumber({ type: 'comNumber', value: option }));
                                    dispatch(setBasicInformation({ field: 'secNumber', value: '', }) );
                                }}
                                open={isOpenTypeId === 'typeOfId'}
                                isNoBorder={true}
                                setOpen={() =>
                                    dispatch(setOpenTypeOfOptions( isOpenTypeId === 'typeOfId' ? null : 'typeOfId' ) )
                                }
                            />
                            <Input
                                type="text"
                                name="secNumber"
                                value={ secNumber }
                                isCustomStyle={true}
                                customCss={`rounded-tr rounded-br w-full text-xs px-2 py-1.5 outline-none ${ !secNumber ? '' : customStyle }`}
                                onChange={handleChange}
                                placeholder="Enter SEC Number"
                                required={true}
                                disabled={!isComplete}
                                maxLength={20}
                            />
                        </div>
                    </div>

                    {/* ====================================================
                        COMPANY MOBILE / TELEPHONE
                    ==================================================== */}
                    <div className="col-span-2 md:col-span-1">
                        <Label
                            label="Mobile/Telephone Number (optional)"
                            fontSize="text-xs mb-1"
                        />
                        <div className={`flex rounded border focus-within:border-[#186cb2] border-gray-300 ${hasValueCompanyNumber ? '' : '' }`}>
                            <ButtonDropdownOption
                                isDisable={!isComplete}
                                width="w-auto"
                                padding="px-2 py-[6px] rounded-l rounded-r-none border-none"
                                options={companyContactNumberOptions}
                                isLoading={isLoadingTypeOfContactNumber}
                                value={companyCompanyNumberValue}
                                onChange={(option) => {
                                    dispatch(setCompanyNumber({ type: 'comContactNumber', value: option, }) );
                                    dispatch(
                                        setBasicInformation({
                                            field: option.id === contactNumberId.telephone.id ? 'companyTelephone' : 'companyMobileNo', 
                                            value: '', 
                                        })
                                    );
                                }}
                                open={ isOpenTypeId === 'typeOfNumber' }
                                isNoBorder={true}
                                setOpen={() => dispatch(setOpenTypeOfOptions(isOpenTypeId === 'typeOfNumber' ? null : 'typeOfNumber' ))}
                            />
                            {companyContactNumber?.id === contactNumberId.mobile.id && (
                                <div className={`flex items-center border-r px-2 text-xs ${ !isComplete ? 'bg-gray-100' : '' }`} >
                                    +63
                                </div>
                            )}
                            <Input
                                type="text"
                                name={companyContactNumber?.id === contactNumberId.telephone.id ? 'companyTelephone' : 'companyMobileNo' }
                                value={companyContactNumber?.id === contactNumberId.telephone.id ? companyTelephone : companyMobileNo }
                                isCustomStyle={true}
                                customCss={`rounded w-full text-xs px-2 py-1.5 outline-none ${!hasValueCompanyNumber ? '' : customStyle }`}
                                onChange={handleChange}
                                placeholder={companyContactNumber?.id !== contactNumberId.telephone.id ? '9123456789' : 'Enter Telephone' }
                                required={true}
                                disabled={!isComplete}
                                maxLength={companyContactNumber?.id === contactNumberId.mobile.id ? 10 : undefined }
                            />
                        </div>
                    </div>
                </div>
                <hr className="h-px border-0 bg-gray-200" />

                {/* ========================================================
                    CONTACT PERSON HEADER
                ======================================================== */}
                <div className="mb-1 flex items-center space-x-2">
                    <div className="rounded bg-[#186db233] p-1">
                        <ContactPersonIcon
                            size={iconSize}
                        />
                    </div>
                    <Label
                        label="Contact Person"
                        fontWeight="font-semibold text-gray-800"
                        fontSize="text-xs"
                        requiredText=" *"
                        isRequired={true}
                    />
                </div>

                {/* ========================================================
                    CONTACT PERSON
                ======================================================== */}
                <div className="grid grid-cols-1 gap-2 text-xs md:grid-cols-2 lg:grid-cols-4">
                    {/* FULL NAME */}
                    <div className="col-span-2 md:col-span-2 lg:col-span-2">
                        <Label
                            label="Full Name (Suffix, First, Middle, Last Name)"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <div className="grid grid-cols-6 gap-1 lg:grid-cols-7">
                            {/* SALUTATION + FIRST NAME */}
                            <div className={`col-span-3 flex rounded border focus-within:border-[#186cb2] border-gray-300 ${contactPersonFirstName ? '' : '' }`}>
                                <div>
                                    <ButtonDropdownOption
                                        isDisable={!isComplete}
                                        width="w-auto"
                                        padding="px-2 py-[6px] rounded-l rounded-r-none border-none"
                                        options={typeOfSuffix}
                                        isLoading={false}
                                        value={contactPersonSuffix}
                                        onChange={(option) => {
                                            dispatch(setBasicInformation({
                                                field:'contactPersonSalutation',
                                                value:option.name
                                            }));
                                        }}
                                        open={ isOpenTypeId === 'typeOfSuffixContPer' }
                                        isNoBorder={true}
                                        setOpen={() => dispatch(setOpenTypeOfOptions(isOpenTypeId === 'typeOfSuffixContPer' ? null : 'typeOfSuffixContPer' ))}
                                    />
                                </div>
                                <Input
                                    type="text"
                                    name="contactPersonFirstName"
                                    value={contactPersonFirstName}
                                    isCustomStyle={true}
                                    customCss={`rounded-tr rounded-br w-full text-xs px-2 py-1.5 outline-none ${!contactPersonFirstName ? '' : customStyle }`}
                                    onChange={handleChange}
                                    required={true}
                                    placeholder="John"
                                    disabled={!isComplete}
                                />

                            </div>
                            {/* MIDDLE NAME */}
                            <Input
                                type="text"
                                name="contactPersonMiddleName"
                                value={contactPersonMiddleName}
                                isCustomStyle={true}
                                customCss={`col-span-1 ${defaultStyle} ${!contactPersonMiddleName ? '' : customStyle }`}
                                onChange={handleChange}
                                required={true}
                                placeholder="D"
                                disabled={!isComplete}
                            />

                            {/* LAST NAME */}
                            <Input
                                type="text"
                                name="contactPersonLastName"
                                value={contactPersonLastName}
                                isCustomStyle={true}
                                customCss={`col-span-2 ${defaultStyle} ${!contactPersonLastName ? '' : customStyle }`}
                                onChange={handleChange}
                                required={true}
                                placeholder="Doe"
                                disabled={!isComplete}
                            />
                        </div>
                    </div>

                    {/* ====================================================
                        CONTACT PERSON MOBILE / TELEPHONE
                    ==================================================== */}
                    <div className="col-span-2 md:col-span-1">
                        <Label
                            label="Mobile/Telephone Number (optional)"
                            fontSize="text-xs mb-1"
                        />
                        <div className={`${hasValueContactPersonNumber ? '' : ''} flex rounded border focus-within:border-[#186cb2] border-gray-300`}>
                            <ButtonDropdownOption
                                isDisable={!isComplete}
                                width="w-auto"
                                padding="px-2 py-[6px] rounded-l rounded-r-none border-none"
                                options={companyContactNumberOptions}
                                isLoading={isLoadingTypeOfContactNumber}
                                value={companyContactPersonNumberValue}
                                onChange={(option) => {
                                    dispatch(setCompanyNumber({
                                        type: 'contactPersonNumber',
                                        value: option,
                                    }));
                                    dispatch(setBasicInformation({
                                        field: option.id === contactNumberId.telephone.id ? 'contactTelephone' : 'contactNumber',
                                        value: '',
                                    }));
                                }}
                                open={ isOpenTypeId === 'typeOfNumberContPer' }
                                isNoBorder={true}
                                setOpen={() =>
                                    dispatch(setOpenTypeOfOptions(isOpenTypeId === 'typeOfNumberContPer' ? null : 'typeOfNumberContPer'))
                                }
                            />
                            {contactPersonNumber?.id === contactNumberId.mobile.id && (
                                <div className={`flex items-center border-r px-2 text-xs ${!isComplete ? 'bg-gray-100' : '' }`}>
                                    +63
                                </div>
                            )}
                            <Input
                                type="text"
                                name={contactPersonNumber?.id === contactNumberId.telephone.id ? 'contactTelephone' : 'contactNumber' }
                                value={contactPersonNumber?.id === contactNumberId.telephone.id ? contactTelephone : contactNumber }
                                isCustomStyle={true}
                                customCss={`rounded-tr rounded-br w-full text-xs px-2 py-1.5 outline-none ${!hasValueContactPersonNumber ? '' : customStyle }`}
                                onChange={handleChange}
                                placeholder={contactPersonNumber?.id !== contactNumberId.telephone.id ? '9123456789' : 'Enter Telephone' }
                                required={true}
                                disabled={!isComplete}
                                maxLength={contactPersonNumber?.id === contactNumberId.mobile.id ? 10 : undefined }
                            />
                        </div>
                    </div>

                    {/* EMAIL */}
                    <div className="col-span-2 md:col-span-1">
                        <Label
                            label="Email"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="email"
                            value={email}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${ !email ? '' : customStyle }`}
                            onChange={handleChange}
                            required={true}
                            placeholder="example@gmail.com"
                            disabled={!isComplete}
                        />
                    </div>

                    {/* DESIGNATION */}
                    <div className="col-span-2 md:col-span-1">
                        <Label
                            label="Designation"
                            fontSize="text-xs mb-1"
                            requiredText=" *"
                            isRequired={true}
                        />
                        <Input
                            type="text"
                            name="designation"
                            value={designation}
                            isCustomStyle={true}
                            customCss={`${defaultStyle} ${!designation ? '' : customStyle }`}
                            onChange={handleChange}
                            required={true}
                            placeholder="Human Resources Officer"
                            disabled={!isComplete}
                        />
                    </div>
                </div>
                {/* ========================================================
                    AFFILIATION
                ======================================================== */}
                <div className="grid grid-cols-1">
                    <div className="min-w-0">
                        <ClientAffiliation />
                    </div>
                </div>
                {/* ========================================================
                    NATURE OF BUSINESS MODAL
                ======================================================== */}
                {isShowIndustries && (
                    <NatureOfBusiness />
                )}
            </div>
        </div>
    );
}